/***
 *
 *   LOADER
 *   Pulse-based loading animation for all loading states
 *
 **********/

import React from "react";
import { ClassHelper } from "components/class";
import { PulseLoader } from "./pulse";
import Style from "./loader.tailwind.js";

export function Loader(props) {
  const size = props.size || 76;
  const loaderStyle = ClassHelper(Style, props);

  const wrapperStyle = props.fullScreen ? {
    position: "fixed",
    top: 0, right: 0, bottom: 0, left: 0,
    width: "100vw",
    height: "100vh",
    transform: "none",
    zIndex: 9999,
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: "blur(1px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } : { width: size, height: size };

  return (
    <div className={loaderStyle} style={{ ...wrapperStyle, ...(props.style || {}) }}>
      <PulseLoader size={size} />
    </div>
  );
}
